<img
  [lazyLoad]="image.url.lazyLoad"
  [defaultImage]="image.url.default"
  [errorImage]="image.url.error"
  [alt]="image.altText"
  [title]="image.titleText"
  width="56px"
  height="56px"
  class="{{ selected ? 'selected' : '' }}"
  src="#"
/>
